import { render, staticRenderFns } from "./EnemResult.vue?vue&type=template&id=ba939fe2&scoped=true&"
import script from "./EnemResult.vue?vue&type=script&lang=ts&"
export * from "./EnemResult.vue?vue&type=script&lang=ts&"
import style0 from "./EnemResult.vue?vue&type=style&index=0&id=ba939fe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba939fe2",
  null
  
)

export default component.exports